import React from "react";
import AnnouncementInputs from "../../../components/Announcement/NewsLetterInput";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import HeaderBread from "../../../components/HeaderBread";
import Layout from "../../../Layout";

const CreateAnnouncement = () => {
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Announcement",
      route: "/website/cms/homepage/announcement",
    },
    {
      title: "Add Announcement",
      route: "/website/cms/homepage/announcement/add",
    },
  ];

  return (
    <Layout type={"create_per"} module_data={"Announcement"}>
      <CustomHeaderTitle title={"Create Announcement"} />
      <HeaderBread
        navigation={navigation}
        title={"Add Announcement"}
      ></HeaderBread>
      <AnnouncementInputs newsletter={{}} />
    </Layout>
  );
};

export default CreateAnnouncement;
